import { $host } from './index'
import { httpPoint } from '../utils/const'


export const getAll = async (page, limit, filters) => {
    const { data } = await $host.post(httpPoint.game + 'getAll', {page, limit, filters})
    return data
}

export const getAllCoin = async (page, limit ) => {
    const { data } = await $host.post(httpPoint.game + 'getAllCoin', {page, limit})
    return data
}

export const getById = async (gameId) => {
    const { data } = await $host.post(httpPoint.game + 'getById', {gameId})
    return data
}

export const getDataForHomePage = async () => {
    const { data } = await $host.post(httpPoint.game + 'getDataForHomePage')
    return data
}